import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
// import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
// import AllAmenities from "./AllAmenities";
// End

// const label = { inputProps: { "aria-label": "Size switch demo" } };

function PendingAmenities() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open2 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl(null);
  };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  // For Modal
  const [open3, setOpen3] = React.useState(false);
  const [scroll3, setScroll3] = React.useState("paper");
  const handleClickOpen3 = (scrollType) => () => {
    setOpen3(true);
    setScroll3(scrollType);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  // const descriptionElementRef3 = React.useRef(null);
  React.useEffect(() => {
    if (open3) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open3]);
  // End

  const addCommitee = () => {
    var element = document.getElementById("successfullAdd");
    element.classList.toggle("hideModal");
  };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Amenities</h1>

            <Button
              className="contentTopLefBt"
              onClick={handleClickOpen("body")}
            >
              Add Amenity
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Pending Amenities</div>
                <div className="visitorListNewInner">
                  <div className="visitorSearch">
                    <div className="visitorSearchDiv">
                      <SearchIcon className="visitorSearchIco" />
                      <input type="text" placeholder="Search" />
                      <MicIcon className="visitorMicIco" />
                    </div>
                    <SortIcon
                      className="visitorFilterIco"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open2}
                      onClose={handleClose2}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={() => navigate("/BookedAmenities")}>
                        Booked Amenities
                      </MenuItem>
                      <MenuItem onClick={() => navigate("/RejectedAmenities")}>
                        Rejected Amenities
                      </MenuItem>
                      <MenuItem onClick={() => navigate("/PendingAmenities")}>
                        Pending Amenities
                      </MenuItem>
                    </Menu>
                  </div>

                  <div className="visitContDiv">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" alt="altimg"/>
                      </Zoom>
                    </div>
                    <div className="visitCont1 resideNewContOut">
                      <div className="visitContLeft">
                        <h3 className="visitContHed">Multipurpose Hall</h3>
                        <p className="visitContTime">Booking date: 7/3/2023</p>
                      </div>
                      <div className="visitBottCont">
                        <p>Booking timeslote</p>
                        <b>12:00pm To 3:30pm</b>
                      </div>
                      <div className="resideNewCont">
                        <b>Paid</b>
                      </div>

                      {/* <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={handleClickOpen2("body")}
                          onClick={() => navigate("/")}
                        />
                        <DeleteIcon className="deleteBt" />
                        <Switch {...label} defaultChecked size="small" />
                      </div> */}
                    </div>
                    <div className="visitCont2">
                      <div className="visitBottCont">
                        <p>Booked by:</p>
                        <b>Prakash jha (Wing A-502)</b>
                      </div>
                      <div className="visitBottCont">
                        <Button className="refuActiveBt apprBt">Approve</Button>
                        <Button
                          className="refuActiveBt rejecBt"
                          onClick={handleClickOpen3("body")}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className="visitContDiv">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://www.nobroker.in/blog/wp-content/uploads/2022/07/Front-And-Back-Door-Layouts-Of-A-Modest-Home-1.jpg" alt="altimg"/>
                      </Zoom>
                    </div>
                    <div className="visitCont1 resideNewContOut">
                      <div className="visitContLeft">
                        <h3 className="visitContHed">Multipurpose Hall</h3>
                        <p className="visitContTime">Booking date: 7/3/2023</p>
                      </div>
                      <div className="visitBottCont">
                        <p>Booking timeslote</p>
                        <b>12:00pm To 3:30pm</b>
                      </div>
                      <div className="resideNewCont notPaidT">
                        <b>Not Paid</b>
                      </div>

                      {/* <div className="resideNewCont">
                        <CreateIcon
                          className="editBt"
                          onClick={handleClickOpen2("body")}
                          onClick={() => navigate("/")}
                        />
                        <DeleteIcon className="deleteBt" />
                        <Switch {...label} defaultChecked size="small" />
                      </div> */}
                    </div>
                    <div className="visitCont2">
                      <div className="visitBottCont">
                        <p>Booked by:</p>
                        <b>Prakash jha (Wing A-502)</b>
                      </div>
                      <div className="visitBottCont">
                        <Button className="refuActiveBt apprBt">Approve</Button>
                        <Button className="refuActiveBt rejecBt">Reject</Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open3}
          // onClose={handleClose3}
          scroll={scroll3}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Message</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent>
            <div className="modalInnerCont snoozOuter">
              <div className="">
                <div id="successfullAdd">
                  <Grid container spacing={3} className="addCommitee1">
                    <Grid item xs={12} md={12}>
                      <div className="modalInput">
                        <textarea
                          className="textAriaSt"
                          placeholder="Enter message of rejection"
                        ></textarea>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="modalMainBtMain">
                        <Button
                          className="modalMainBt rejectBtSt"
                          onClick={addCommitee}
                        >
                          Reject
                        </Button>
                      </div>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} className="addCommitee2">
                    <Grid item xs={12} md={12}>
                      <div className="succesMain">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" alt="altimg"/>
                        <h4>Success !</h4>
                        <p>
                          Request Rejected <br />
                          successfully
                        </p>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default PendingAmenities;
